import { coreAuditTrailIcon } from './audit-trail';
import { coreCaseOverviewIcon } from './case-overview';
import { coreCustomerIcon } from './customer';
import { coreDxtectiveIcon } from './dxtective';
import { coreHomeIcon } from './home';
import { coreLeadershipViewIcon } from './leadership-view';
import { coreMlroViewIcon } from './mlro-view';
import { coreMonitoringIcon } from './monitoring';
import { coreSarOfficerIcon } from './sar-officer';
import { coreSettingsIconActiveIcon } from './settings-icon-active';
import { coreSettingsIcon } from './settings';
import { coreUploadDataIcon } from './upload-data';
import { coreUserManagementIcon } from './user-management';
export const navIcons = [coreAuditTrailIcon, coreCaseOverviewIcon, coreCustomerIcon, coreDxtectiveIcon, coreHomeIcon, coreLeadershipViewIcon, coreMlroViewIcon, coreMonitoringIcon, coreSarOfficerIcon, coreSettingsIconActiveIcon, coreSettingsIcon, coreUploadDataIcon, coreUserManagementIcon];
